var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacher-element",class:{ 'in-work': _vm.inWork }},[_c('vs-avatar',{attrs:{"src":_vm.teacher.options && _vm.teacher.options.avatar
        ? (_vm.proxy + "/static/files/" + (_vm.teacher.options.avatar))
        : undefined,"size":_vm.size}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }